import { dispatch } from "../store/store";
import { logErrorWithPayload } from "../services/logService";
import {
  getServicesTabData,
  getAnalyticsReportsData,
  getMembersTabData,
  fetchAllAnalyticsReportsData,
  fetchAnalyticsReportById,
  getServiceDetailsData,
  getMemberDetailsData,
} from "../features/analyticsSlice/analyticsSlice";

export const fetchServicesTab = async (params) => {
  return await dispatch(getServicesTabData(params));
};

export const fetchMembersTab = async (params) => {
  let result = null;
  try {
    // We use unwrap() so the caller can catch errors if needed
    result = await dispatch(getMembersTabData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
  }
  return result;
};

export const getAnalyticsReports = async () => {
  let result = null;
  try {
    result = await dispatch(getAnalyticsReportsData()).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
  }
  return result;
};

export const fetchAllReports = async (params) => {
  let result = null;
  try {
    // params should contain { companyID, pharmacyID }
    result = await dispatch(fetchAllAnalyticsReportsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
  }
  return result;
};

export const fetchReportById = async (params) => {
  let result = null;
  try {
    // params should contain { reportID, startDate, endDate, companyID, pharmacyID }
    result = await dispatch(fetchAnalyticsReportById(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
  }
  return result;
};

export const getServiceDetails = async (params) => {
  let result = null;
  try {
    result = await dispatch(getServiceDetailsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
  }
  return result;
};

export const getMemberDetails = async (params) => {
  let result = null;
  try {
    result = await dispatch(getMemberDetailsData(params)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
  }
  return result;
};
